export default __webpack_public_path__ + "static/media/logo.078371a1.svg";